import * as React from 'react'
import * as routes from '../../constants/routes'
import {Link} from 'gatsby-plugin-react-i18next'
import {useTranslation} from 'react-i18next'
import joinClassNames from '../../helpers/joinClassNames'

type Props = {
    isPrimary?: boolean
    isOutlined?: boolean
    isRounded?: boolean
    isFullWidthMobile?: boolean
    size?: 'large' | 'medium'
    className?: string
}

const RegisterButton = ({
    isPrimary = true,
    isOutlined = true,
    isRounded = true,
    isFullWidthMobile = true,
    size = 'large',
    className,
}: Props) => {
    const {t} = useTranslation()

    const classNames = joinClassNames(
        'button',
        isPrimary && 'is-primary',
        isRounded && 'is-rounded',
        isOutlined && 'is-outlined',
        isFullWidthMobile && 'is-fullwidth-mobile',
        `is-${size}`,
        className
    )

    return (
        //Analytics id="start1"
        <Link to={routes.REGISTER} id="start1" className={classNames}>
            {t('invite-section_read_more')}
        </Link>
    )
}

export default RegisterButton
